import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Redirects old /reset_password?token=X URLs to /login?token=X
 * The login page now handles both new user setup and password reset via magic links.
 */
const ResetPasswordRedirect = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  // Redirect to /login, preserving the token parameter
  const redirectPath = token ? `/login?token=${token}` : "/login";

  return <Navigate to={redirectPath} replace />;
};

export default ResetPasswordRedirect;
